import {
  isObject,
  extend,
  ssrDocument,
  ssr_window_esm_getDocument,
  ssrWindow,
  ssr_window_esm_getWindow,
  utils_classesToTokens,
  deleteProps,
  utils_nextTick,
  utils_now,
  utils_getComputedStyle,
  utils_getTranslate,
  utils_isObject,
  isNode,
  utils_extend,
  utils_setCSSProperty,
  animateCSSModeScroll,
  utils_getSlideTransformEl,
  utils_elementChildren,
  elementIsChildOfSlot,
  elementIsChildOf,
  showWarning,
  utils_createElement,
  utils_elementOffset,
  elementPrevAll,
  elementNextAll,
  elementStyle,
  elementIndex,
  utils_elementParents,
  utils_elementTransitionEnd,
  elementOuterSize,
  utils_makeElementsArray,
  utils_getRotateFix,
  support,
  calcSupport,
  getSupport,
  deviceCached,
  calcDevice,
  getDevice,
  browser,
  calcBrowser,
  getBrowser,
  Resize,
  Observer,
  eventsEmitter,
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  toggleSlideClasses$1,
  updateSlidesProgress,
  updateProgress,
  toggleSlideClasses,
  updateSlidesClasses,
  processLazyPreloader,
  unlazy,
  preload,
  getActiveIndexByTranslate,
  updateActiveIndex,
  updateClickedSlide,
  update,
  getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo,
  translate,
  setTransition,
  transitionEmit,
  transitionStart,
  transitionEnd,
  transition,
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide,
  slide,
  loopCreate,
  loopFix,
  loopDestroy,
  loop,
  setGrabCursor,
  unsetGrabCursor,
  grabCursor,
  closestElement,
  preventEdgeSwipe,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onResize,
  onClick,
  onScroll,
  onLoad,
  onDocumentTouchStart,
  events,
  attachEvents,
  detachEvents,
  events$1,
  isGridEnabled,
  setBreakpoint,
  getBreakpoint,
  breakpoints,
  prepareClasses,
  addClasses,
  removeClasses,
  classes,
  checkOverflow,
  checkOverflow$1,
  defaults,
  moduleExtendParams,
  prototypes,
  extendedDefaults,
  Swiper,
  Virtual,
  Keyboard,
  Mousewheel,
  create_element_if_not_defined_createElementIfNotDefined,
  Navigation,
  classes_to_selector_classesToSelector,
  Pagination,
  Scrollbar,
  Parallax,
  Zoom,
  Controller,
  A11y,
  History,
  HashNavigation,
  Autoplay,
  Thumb,
  freeMode,
  effect_init_effectInit,
  effect_target_effectTarget,
  effect_virtual_transition_end_effectVirtualTransitionEnd,
  EffectFade,
  EffectCube,
  create_shadow_createShadow,
  EffectFlip,
  EffectCoverflow,
  EffectCreative,
  EffectCards
} from "ccc-swiper";
/* CCC: swiper was inlined here by Flow's build; it now comes from the
   shared module above. See _upgrade-kit/README.md. */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/javascripts/webcomponents/navigation-banner.js



var isDefined = customElements.get('nav-banner');

if (!isDefined) {
  class NavBanner extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.nextEl = this.querySelector('[data-nav-banner-next]');
      this.initSwiper = this.initSwiper.bind(this);
    }

    connectedCallback() {
      window.wetheme.webcomponentRegistry.register({key: 'component-navigation-banner'});
      this.initSwiper();
    }

    initSwiper() {
      const gridSpacingMobile = parseInt(this.dataset.gridSpacingMobile, 10) || 15;
      const gridSpacingDesktop = parseInt(this.dataset.gridSpacingDesktop, 10) || 30;

      this.swiper = new Swiper(this.swiperEl, {
        modules: [A11y, Navigation, Mousewheel],
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        spaceBetween: gridSpacingMobile,
        centerInsufficientSlides: this.swiperCenter,
        navigation: {
          nextEl: this.nextEl
        },
        mousewheel: {
          invert: false,
        },
        breakpoints: {
          768: { spaceBetween: gridSpacingDesktop }
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
    }

    get swiperCenter() {
      return this.getAttribute('data-swiper-center') === 'true';
    }
  }

  customElements.define('nav-banner', NavBanner);
}

/******/ })()
;